<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar o agrotóxico <b>{{this.entry.description}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(agrotoxic) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_AGROTOXIC_MUTATION,
          variables: {
            id: agrotoxic.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyAgrotoxic.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_AGROTOXIC_MUTATION = gql `
  mutation($id: ID!) {
    destroyAgrotoxic(id: $id) {
      item {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>